module.exports = __webpack_public_path__ + "static/index/img/baikal-805.0a536885.jpg";